module.exports = __webpack_public_path__ + "static/media/AddField.a1e74fd5.svg";